import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=3bf893c0&scoped=true"
import script from "./Simulator.vue?vue&type=script&lang=js"
export * from "./Simulator.vue?vue&type=script&lang=js"
import style0 from "./Simulator.vue?vue&type=style&index=0&id=3bf893c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf893c0",
  null
  
)

export default component.exports